
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transparency/donations/[date]",
      function () {
        return require("private-next-pages/transparency/donations/[date].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transparency/donations/[date]"])
      });
    }
  